import { Helmet } from 'react-helmet-async';
import React from 'react';
import ChangeStrategySettingsFormContainer from '../../../containers/projects/ChangeStrategySettingsFormContainer.jsx';

import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const ChangeStrategySettings = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>Change Strategy Settings | ChangeSync</title>
    </Helmet>
    <ChangeStrategySettingsFormContainer projectId={projectId} slug={slug} />
  </>
);

ChangeStrategySettings.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(ChangeStrategySettings));
